import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';

const BmsmChart = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$local.$bmsmChart' });

  return (
    <div className="bmsm-chart">
      <table>
        <tbody>
          <tr>
            <td className="spend-header spend-col">{t('spend')}</td>
            <td className="save-header save-col">{t('save')}</td>
          </tr>
          <tr>
            <td className="spend-col">{t('spend_1')}</td>
            <td className="save-col">{t('save_1')}</td>
          </tr>
          <tr>
            <td className="spend-col">{t('spend_2')}</td>
            <td className="save-col">{t('save_2')}</td>
          </tr>
          <tr>
            <td className="spend-col">{t('spend_3')}</td>
            <td className="save-col">{t('save_3')}</td>
          </tr>
          <tr>
            <td className="spend-col">{t('spend_4')}</td>
            <td className="save-col">{t('save_4')}</td>
          </tr>
          <tr>
            <td className="spend-col">{t('spend_5')}</td>
            <td className="save-col">{t('save_5')}</td>
          </tr>
          <tr>
            <td className="spend-col">{t('spend_6')}</td>
            <td className="save-col">{t('save_6')}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default BmsmChart;
